module.exports = "/img/_/_/_/assets/images/icon//limitpoints.png?d61263791547fb744a0ce966097db3d6";